import { icons } from "@patient-watch/icons";
import { commonComponents as e } from "@/components/common";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const UploadComplete = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (localStorage.getItem("prolific") === "true") {
            window.location.replace("https://form.jotform.com/230876676076065");
        }
    }, []);
    return (
        <div className="flex-col justify-between items-stretch content-between mx-auto px-2 w-full h-full">
            <e.Title words="Complete" />
            <div className="my-10">
                <div className="flex-col justify-center mx-auto mt-4 mb-6 w-[50vw] max-w-[250px]">
                    <icons.CelebrateSittingDrawing />
                </div>
                <p className="block justify-center items-center pt-4 w-full text-lg text-center">
                    Complete our 2 minute{" "}
                    <span className="font-semibold text-indigo-600 underline underline-offset-1">
                        <a href="https://form.jotform.com/230876676076065">survey</a>
                    </span>{" "}
                    on what features Foot Watch needs or click Next to go to see your uploaded photos.
                </p>
            </div>
            <e.Button btn="btn-1" words="Next" onClick={() => navigate("/")} />
        </div>
    );
};

export const Route = createFileRoute("/_app/foot-watch/$diaryId/new/upload/complete")({
    component: UploadComplete,
});
